export default __webpack_public_path__ + "static/media/coach.b6e05e05.png";